import { useState } from "react";
import { Plus } from "lucide-react";

const faqs = [
  {
    q: "¿Cuánto cuesta un techo FlexShade?",
    a: "El precio depende del tamaño, modelo y material elegido. Los proyectos van desde instalaciones residenciales hasta grandes estacionamientos corporativos. Solicita tu cotización personalizada gratuita y te entregamos diseño y presupuesto en 24 horas.",
  },
  {
    q: "¿FlexShade necesita permiso de construcción?",
    a: "No. FlexShade es un sistema modular prefabricado desmontable, por lo que no requiere permiso municipal de construcción. Esto te ahorra meses de trámites y miles de pesos.",
  },
  {
    q: "¿Cuánto tarda la instalación?",
    a: "Dependiendo del tamaño del proyecto, la instalación se realiza en pocos días. Un estacionamiento mediano puede instalarse en 3 a 7 días laborales. No hay soldadura en sitio, lo que acelera mucho el proceso.",
  },
  {
    q: "¿Cuál es la diferencia entre malla sombra y membrana PVC?",
    a: "La malla sombra arquitectónica bloquea hasta 95% de UV y es semi impermeable (~80%). La membrana PVC es 100% impermeable y ofrece cobertura total frente a lluvia directa. Elegimos el material según tus necesidades y presupuesto.",
  },
  {
    q: "¿Qué incluye la garantía?",
    a: "Garantía por escrito de 10 hasta 20 años cubriendo materiales y mano de obra. Depende del material elegido. Todas nuestras garantías son reales, por escrito y respaldadas por Eclipse con 20 años en el mercado.",
  },
  {
    q: "¿En qué ciudades instalan?",
    a: "Tenemos instalación propia en más de 30 ciudades del país: Monterrey, Saltillo, Torreón, Chihuahua, Tamaulipas, Bajío, CDMX y muchas más. Cubrimos todo el norte de México y gran parte de Latinoamérica.",
  },
  {
    q: "¿Resiste lluvia y viento?",
    a: "Sí. FlexShade está diseñado para resistir vientos de hasta 70 km/h. Con malla sombra tienes proteccion ~80% a lluvia y con membrana PVC tienes proteccion 100%. Nuestra ingeniería y materiales importados garantizan durabilidad real.",
  },
  {
    q: "¿Cuánta área cubre un solo módulo?",
    a: "Cada módulo está dimensionado estándar para cubrir de 2 a 6 autos (dependiendo del modelo). Se combinan módulos para cubrir desde 1 cajon residencial hasta miles de metros cuadrados en corporativos.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(-1);
  return (
    <section id="faq" className="bg-neutral-50 py-20 md:py-28">
      <div className="container-x max-w-4xl">
        <div className="text-center mb-12">
          <span className="eyebrow">FAQ</span>
          <h2 className="mt-4 section-title text-4xl md:text-6xl font-black">
            Preguntas <span className="text-red-600">frecuentes</span>
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="bg-white rounded-xl border border-neutral-200 overflow-hidden" data-testid={`faq-${i}`}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full text-left p-5 md:p-6 flex items-start justify-between gap-4 hover:bg-neutral-50 transition"
                  aria-expanded={isOpen}
                >
                  <h3 className="font-bold text-base md:text-lg text-neutral-900">{f.q}</h3>
                  <div className={`w-7 h-7 bg-red-600/10 text-red-600 rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`}>
                    <Plus className="w-4 h-4" />
                  </div>
                </button>
                {isOpen && (
                  <div className="px-5 md:px-6 pb-5 md:pb-6 -mt-1">
                    <p className="text-neutral-600 leading-relaxed">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }} />
      </div>
    </section>
  );
}
